<div class="container">
    <div class="title">{{data.title |translate}}</div> <br />
    <div class="subtitle">{{data.subtitle1 |translate }} </div> <br />
    <div class="body">{{data.label1 |translate }}</div>
    <br />
    <div class="subtitle">{{data.subtitle2 |translate }} </div> <br />
    <div class="body">{{data.label2 |translate }}</div>
    <br />
    <div class="subtitle">{{data.subtitle3 |translate }} </div> <br />
    <div class="body">{{data.label3 |translate }}</div>
    <br />
    <div class="subtitle">{{data.subtitle4 |translate }} </div> <br />
    <div class="subtitle">{{data.subtitle4a |translate }}</div> <br />
    <div class="body">{{data.label4a |translate }}</div>
    <br />
    <div class="subtitle">{{data.subtitle4b |translate }}</div> <br />
    <div class="body">{{data.label4b |translate }}</div> <br />
    <br />
    <div class="subtitle">{{data.subtitle4c |translate }}</div> <br />
    <div class="body">{{data.label4c |translate }}</div>
    <br />
    <div class="subtitle">{{data.subtitle5 |translate }}</div> <br />
    <div class="body">{{data.label5 |translate }}</div>
    <br />
    <div class="subtitle">{{data.subtitle6 |translate }}</div> <br />
    <div class="body">{{data.label6 |translate }}</div>
    <br />
    <div class="subtitle">{{data.subtitle7 |translate }}</div> <br />
    <div class="body">{{data.label7 |translate }}</div>
    <br />
    <div class="subtitle">{{data.subtitle8 |translate }} </div> <br />
    <div class="subtitle">{{data.subtitle8a |translate }}</div> <br />
    <div class="body">{{data.label8a |translate }}</div>
    <br />
    <div class="subtitle">{{data.subtitle8b |translate }}</div> <br />
    <div class="body">{{data.label8b |translate }}</div>
    <br />
    <div class="subtitle">{{data.subtitle9 |translate }}</div> <br />
    <div class="body">{{data.label9 |translate }}</div>
    <br />
    <div class="subtitle">{{data.subtitle10 |translate }}</div> <br />
    <div class="body">{{data.label10 |translate }}</div>
    <br />
</div>
<div class="button-bar">
    <div class="button" (click)="onNoClick()">retour</div>
</div>